import { render, staticRenderFns } from "./CarouselUsers.vue?vue&type=template&id=2b368be3"
import script from "./CarouselUsers.vue?vue&type=script&lang=js"
export * from "./CarouselUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports